(function() {
    'use strict';

    angular
        .module('account')
        .component('changePassword', {
            bindings: { },
            templateUrl: '/account/views/changepassword.html',
            controller: [
                '$stateParams',
                'FacilitySecurityRepository',
                'gettext',
                'LocalStorageRepository',
                'toaster',
                'TransitionManager',
                ChangePassword
            ],
        });

    function ChangePassword(
        $stateParams,
        FacilitySecurityRepository,
        gettext,
        LocalStorageRepository,
        toaster,
        TransitionManager
    ) {
        var vm = this;
        
        vm.confirmNewPassword = '';
        vm.loading = false;
        vm.userName = '';

        vm.model = {
            Id: LocalStorageRepository.getUserID(),
            OldPassword: '',
            NewPassword: ''
        };
        
        vm.back = back;
        vm.submit = submit;
        
        vm.$onInit = function() {
            vm.isActiveDirectoryUser = LocalStorageRepository.getIsActiveDirectoryUser();
            vm.userName = LocalStorageRepository.getUserName();
        };

        function back() {
            TransitionManager.goBack();
        }

        function submit(form) {
            if (form.$invalid) {
                return;
            }          

            vm.loading = true;

            FacilitySecurityRepository.postChangePassword(vm.model)
                .then(function () {
                    toaster.pop('success', '', gettext('Password has been changed successfully. Please login with new password.'));
                    TransitionManager.transition({appRoute: 'login'});
                })
                .catch(function (error) {
                    toaster.pop('error', '', gettext(error.data));
                })
                .finally(function () {
                    vm.loading = false;
                });
        }
    }
})();